import CryptoJS from "crypto-js";
import {Buffer} from "buffer";

const encrypt = (key_text, iv_text, data) => {
  const key = CryptoJS.SHA256(key_text);
  const iv = CryptoJS.enc.Utf8.parse(iv_text);
  const encrypted = CryptoJS.AES.encrypt(data, key, {iv: iv});

  return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
}

const decrypt = (key_text, iv_text, data) => {
  const key = CryptoJS.SHA256(key_text);
  const iv = CryptoJS.enc.Utf8.parse(iv_text);
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(data) }, key, { iv: iv });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

const b64enc = (data) => {
  var b   = new Buffer.from(data, "binary");
  return b.toString("base64");
}

export { encrypt, decrypt, b64enc }
